import { ChangeDetectionStrategy, Component, Injector, Input, OnInit, ViewEncapsulation } from '@angular/core';
import {
    IOnboardingAssignee,
    IOnboardingAssigneesItem,
    IOnboardingAssigneesSave,
} from '@fi-app/fi-onboarding/fi-onboarding-synchronized/fi-onboarding-synchronized';
import { FiProfileSizes, IUserProfile } from '@fi-shared/profile-icon/profile-icon.component';
import { FiOnboardingSynchronizedService } from '@fi-app/fi-onboarding/fi-onboarding-synchronized/fi-onboarding-synchronized.service';
import { FiInfiniteScrollDataSource, TSortOrder } from '@fi-shared/fi-items-list/fi-infinite-scroll-data-source';
import { FiItemsListType } from '@fi-shared/fi-items-list/fi-items-list-type';
import { ObjectTypes } from '@fi-shared/types';
import { Subject } from 'rxjs';

@Component({
    selector: 'fi-onboarding-assign-users',
    templateUrl: './fi-onboarding-assign-users.component.html',
    styleUrl: './fi-onboarding-assign-users.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-onboarding-assign-users' },
    standalone: false,
})
export class FiOnboardingAssignUsersComponent
    extends FiInfiniteScrollDataSource<IOnboardingAssignee>
    implements OnInit
{
    @Input() onboardingAssigneesItem: IOnboardingAssigneesItem;

    itemsListType = FiItemsListType.OnboardingAssigneesList;
    objectType = ObjectTypes.Onboarding;
    protected readonly UserColumnName = 'Name';
    protected onboardingAssigneesChanged$ = new Subject<void>();

    constructor(
        injector: Injector,
        private fiOnboardingSynchronizedService: FiOnboardingSynchronizedService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.reloadData();
    }

    getListData(): Promise<IOnboardingAssignee[]> {
        return Promise.resolve(this.onboardingAssigneesItem.OnboardingAssignees);
    }

    protected getSortOrderFn(): TSortOrder<IOnboardingAssignee> {
        if (this.selectedSort.active === this.UserColumnName) return this.getUserNameSort.bind(this);

        return super.getSortOrderFn();
    }

    private getUserNameSort(item: IOnboardingAssignee): string {
        return item.UserProfile.FullName;
    }

    protected getMatserUser(item: IOnboardingAssignee): IUserProfile {
        return this.onboardingAssigneesItem.MasterUsers.find((masterUser) => masterUser.Id === item.MasterUserId);
    }

    onAssignedMasterUserChanged($event: IOnboardingAssignee) {
        const dataForSave: IOnboardingAssigneesSave = {
            OnboardingId: this.onboardingAssigneesItem.OnboardingId,
            OnboardingAssignees: [
                {
                    UserId: $event.UserId,
                    MasterUserId: $event.MasterUserId,
                },
            ],
        };
        this.fiOnboardingSynchronizedService.saveOnboardingAssignees(dataForSave).then(() => {
            this.onboardingAssigneesChanged$.next();
        });
    }

    protected readonly FiProfileSizes = FiProfileSizes;
}
